// ScreenContext.js

'use client'

import React, { createContext, useState, useEffect } from "react";

// Create the context with an initial value
const ScreenContext = createContext({});

export const ScreenProvider = ({ children }) => {

  // Define the state to track screen sizes
  const [screen, setScreen] = useState({
    mobile: false,
    tablet: false,
    desktop: true,
    scroll: 0,
  });

  useEffect(() => {
    const handleResizeAndScroll = () => {
      const size = window.innerWidth;
      const scroll = window.scrollY;

      setScreen({
        mobile: size < 768,
        tablet: size >= 768 && size < 1200,
        desktop: size >= 1200,
        scroll: scroll,
      });
    };

    handleResizeAndScroll();

    window.addEventListener("resize", handleResizeAndScroll);
    window.addEventListener("scroll", handleResizeAndScroll);

    return () => {
      window.removeEventListener("resize", handleResizeAndScroll);
      window.removeEventListener("scroll", handleResizeAndScroll);
    };
  }, []);

  return (
    <ScreenContext.Provider value={screen}>
      {children}
    </ScreenContext.Provider>
  );
};

export default ScreenContext;
